"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6073],{

/***/ 19659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C_": function() { return /* binding */ TravelPassTrackEvents; },
/* harmony export */   "Ck": function() { return /* binding */ HindustanTimesPartner; },
/* harmony export */   "E8": function() { return /* binding */ TRAVEL; },
/* harmony export */   "G$": function() { return /* binding */ TravelInsuranceTrackEvents; },
/* harmony export */   "I6": function() { return /* binding */ TravelInsurancePages; },
/* harmony export */   "TV": function() { return /* binding */ AppsFlyer; },
/* harmony export */   "Tk": function() { return /* binding */ AppsFlyerEvents; },
/* harmony export */   "ZD": function() { return /* binding */ VasPages; },
/* harmony export */   "e2": function() { return /* binding */ TravelInsuranceViewEvents; },
/* harmony export */   "hE": function() { return /* binding */ DOMESTIC_PASS; },
/* harmony export */   "iC": function() { return /* binding */ VasTrackEvents; },
/* harmony export */   "lO": function() { return /* binding */ VasViewEvents; },
/* harmony export */   "tH": function() { return /* binding */ TravelPassPages; },
/* harmony export */   "tw": function() { return /* binding */ EventType; },
/* harmony export */   "uT": function() { return /* binding */ TravelPassViewEvents; },
/* harmony export */   "xM": function() { return /* binding */ VAS; }
/* harmony export */ });
var TRAVEL = {
    PRODUCT: "travel",
    JOURNEY: "buy",
    SUB_PRODUCT_NAME: "international_travel",
    COUPON_JOURNEY: "couponing",
    SEO: "seo"
};
var TravelInsurancePages;
(function(TravelInsurancePages) {
    TravelInsurancePages["HOME"] = "home";
    TravelInsurancePages["SEO"] = "travel-insurance";
    TravelInsurancePages["TRAVEL_ALL_TRIPS"] = "travel_all_trips";
    TravelInsurancePages["INT_LANDING_PAGE"] = "int_landing_page";
    TravelInsurancePages["INT_TRAVEL_FORK_SCREEN"] = "int_travel_fork_screen";
    TravelInsurancePages["INT_TRAVEL_TRIP_INFO_SCREEN"] = "int_travel_trip_info_screen";
    TravelInsurancePages["INT_TRAVEL_BUNDLED_PLAN_SELECTION_SCREEN"] = "int_travel_bundled_plan_selection_screen";
    TravelInsurancePages["INT_TRAVEL_BUNDLED_ADDON_SCREEN"] = "int_travel_bundled_add_on_screen";
    TravelInsurancePages["INT_TRAVEL_REVIEW_SCREEN"] = "int_travel_review_screen";
    TravelInsurancePages["INT_TRAVEL_UNBUNDLED_MEDICAL_COVER"] = "int_travel_unbundled_medical_cover";
    TravelInsurancePages["INT_TRAVEL_UNBUNDLED_TRIP_COVER"] = "int_travel_unbundled_trip_cover";
    TravelInsurancePages["INT_TRAVEL_UNBUNDLED_BAGGAGE_COVER"] = "int_travel_unbundled_baggage_cover";
    TravelInsurancePages["INT_TRAVEL_ADD_COVER_NUDGE_MODAL"] = "int_travel_add_cover_nudge_modal";
    TravelInsurancePages["INT_TRAVEL_ADD_ON_NUDGE_MODAL"] = "int_travel_add_on_nudge_modal";
    TravelInsurancePages["INT_TRAVEL_MEDICAL_INSURANCE_MANDATORY_MODAL"] = "int_travel_medical_insurance_mandatory_modal";
    TravelInsurancePages["INT_TRAVEL_MEDICAL_COVER_PERSUASION_MODAL"] = "int_travel_medical_cover_persuasion_modal";
    TravelInsurancePages["INT_TRAVEL_TRIP_COVER_PERSUASION_MODAL"] = "int_travel_trip_cover_persuasion_modal";
    TravelInsurancePages["INT_TRAVEL_BAGGAGE_COVER_PERSUASION_MODAL"] = "int_travel_baggage_cover_persuasion_modal";
    TravelInsurancePages["INT_TRAVEL_POST_PAYMENT_ADD_DETAILS_SCREEN"] = "int_travel_post_payment_add_details_screen";
    TravelInsurancePages["INT_TRAVEL_POST_PAYMENT_ADD_DETAILS_NUDGE"] = "int_travel_post_payment_add_details_nudge";
    TravelInsurancePages["INT_TRAVEL_TRAVELLERS_DETAILS_SCREEN"] = "int_travel_travellers_details_screen";
    TravelInsurancePages["INT_TRAVEL_BUY_JOURNEY_SUCCESS_SCREEN"] = "int_travel_buy_journey_success_screen";
    TravelInsurancePages["INT_TRAVEL_POST_PAYMENT_DOWNLOAD_APP"] = "int_travel_post_payment_download_app";
    TravelInsurancePages["INT_TRAVEL_POST_PAYMENT_TRAVELLERS_DETAILS"] = "int_travel_post_payment_travellers_details";
    TravelInsurancePages["INT_TRAVEL_HELP_SCREEN"] = "int_travel_help_screen";
    TravelInsurancePages["INT_TRAVEL_PAYMENT_PENDING_SCREEN"] = "int_travel_payment_pending_screen";
    TravelInsurancePages["INT_TRAVEL_VERIFY_PAYMENT_SCREEN"] = "int_travel_verify_payment_screen";
    TravelInsurancePages["INT_TRAVEL_COUPON_LIST"] = "int_travel_coupon_list";
    TravelInsurancePages["INT_TRAVEL_WIDGET_HT"] = "int_travel_widget_ht";
    TravelInsurancePages["INT_TRAVEL_PAYMENT_INITIATION_LOADER"] = "int_travel_payment_initiation_loader";
    TravelInsurancePages["INT_TRAVEL_POST_PAYMENT_TRAVELLERS_DETAILS_SCREEN"] = "int_travel_post_payment_travellers_details_screen";
    TravelInsurancePages["INT_LANDING_PAGE_COVERAGE_EXPLAINER"] = "int_landing_page_coverage_explainer";
    TravelInsurancePages["INT_LANDING_PAGE_CLAIMS_EXPLAINER"] = "int_landing_page_claims_explainer";
    TravelInsurancePages["INT_LANDING_PAGE_FLEXIBILITY_SECTION"] = "int_landing_page_flexibility_section";
    TravelInsurancePages["INT_LANDING_PAGE_CUSTOMER_SUPPORT_SECTION"] = "int_landing_page_customer_support_section";
    TravelInsurancePages["INT_LANDING_PAGE_TESTIMONIAL_SECTION"] = "int_landing_page_testimonial_section";
    TravelInsurancePages["INT_LANDING_PAGE_FAQ_SECTION"] = "int_landing_page_faq_section";
    TravelInsurancePages["INT_TRIP_INFO_PAGE"] = "int_trip_info_page";
})(TravelInsurancePages || (TravelInsurancePages = {}));
var TravelInsuranceViewEvents;
(function(TravelInsuranceViewEvents) {
    TravelInsuranceViewEvents["VIEW_INT_LANDING_PAGE"] = "view_int_landing_page";
    TravelInsuranceViewEvents["VIEW_INT_TRIP_INFO_SCREEN"] = "view_int_trip_info_screen";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_FORK_SCREEN"] = "view_page_int_fork_screen";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_TRIP_INFO_SCREEN"] = "view_page_int_trip_info_screen";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_BUNDLED_PLAN"] = "view_page_int_bundled_plan";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_BUNDLED_ADD_ON"] = "view_page_int_bundled_add_on";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_REVIEW"] = "view_page_int_review";
    TravelInsuranceViewEvents["VIEW_INT_PAGE_PAYMENT_SUCCESS"] = "view_int_page_payment_success";
    TravelInsuranceViewEvents["VIEW_INT_PAGE_POST_PAYMENT_DETAILS_PENDING"] = "view_int_page_post_payment_details_pending";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_MEDICAL_COVER"] = "view_page_int_medical_cover";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_TRIP_COVER"] = "view_page_int_trip_cover";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_BAGGAGE_COVER"] = "view_page_int_baggage_cover";
    TravelInsuranceViewEvents["VIEW_MODAL_INT_ADD_COVER_NUDGE"] = "view_modal_int_add_cover_nudge";
    TravelInsuranceViewEvents["VIEW_MODAL_INT_ADD_ON_NUDGE"] = "view_modal_int_add_on_nudge";
    TravelInsuranceViewEvents["VIEW_MODAL_INT_MEDICAL_INSURANCE_MANDATORY_NUDGE"] = "view_modal_int_medical_insurance_mandatory_nudge";
    TravelInsuranceViewEvents["VIEW_MODAL_INT_COVER_PERSUASION"] = "view_modal_int_cover_persuasion";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_TRAVELLERS_DETAILS"] = "view_page_int_travellers_details";
    TravelInsuranceViewEvents["VIEW_MODAL_INT_PRICE_UPDATE"] = "view_modal_int_price_update";
    TravelInsuranceViewEvents["VIEW_MODAL_INT_COVERAGE_UPDATE"] = "view_modal_int_coverage_update";
    TravelInsuranceViewEvents["VIEW_MODAL_INT_TRAVELLER_AGE_UPDATE"] = "view_modal_int_traveller_age_update";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_BUY_JOURNEY_SUCCESS"] = "view_page_int_buy_journey_success";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_POST_ISSUANCE_DOWNLOAD_APP"] = "view_page_int_post_issuance_download_app";
    TravelInsuranceViewEvents["VIEW_PAGE_PAYMENT_SUCCESS_ADD_DETAILS"] = "view_page_payment_success_add_details";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_HELP"] = "view_page_int_help";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_PAYMENT_PENDING"] = "view_page_int_payment_pending";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_ERROR"] = "view_page_int_error";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_COUPON_LIST"] = "view_page_int_coupon_list";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_COUPON_APPLIED"] = "view_page_int_coupon_applied";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_PAYMENT_INITIATION"] = "view_page_int_payment_initiation";
    TravelInsuranceViewEvents["VIEW_COUPON_NUDGE"] = "view_coupon_nudge";
    TravelInsuranceViewEvents["VIEW_COUPON_SCROLL"] = "view_coupon_scroll";
    TravelInsuranceViewEvents["VIEW_TRAVEL_WIDGET_HT"] = "view_travel_widget_ht";
    TravelInsuranceViewEvents["VIEW_PAGE_CIS_CONFIRMATION"] = "view_page_cis_confirmation";
    TravelInsuranceViewEvents["VIEW_PAGE_INT_TRAVELLERS_DETAILS_POST_PAYMENT"] = "view_page_int_travellers_details_post_payment";
    TravelInsuranceViewEvents["VIEW_PAGE_ALL_TRIPS"] = "view_page_all_trips";
    TravelInsuranceViewEvents["VIEW_COUNTRY_DETAIL_CARD"] = "view_country_detail_card";
    TravelInsuranceViewEvents["VIEW_TRAVELLER_COUNT_CARD"] = "view_traveller_count_card";
    TravelInsuranceViewEvents["VIEW_TRIP_DURATION_CARD"] = "view_trip_duration_card";
    TravelInsuranceViewEvents["VIEW_FORK_SCREEN_CARD"] = "view_fork_screen_card";
    TravelInsuranceViewEvents["VIEW_OTHER_PLANS_COMPARISON"] = "view_other_plans_comparison";
})(TravelInsuranceViewEvents || (TravelInsuranceViewEvents = {}));
var TravelInsuranceTrackEvents;
(function(TravelInsuranceTrackEvents) {
    TravelInsuranceTrackEvents["TAP_BTN_INT_HELP"] = "tap_btn_int_help";
    TravelInsuranceTrackEvents["TAP_BTN_INT_BACK"] = "tap_btn_int_back";
    TravelInsuranceTrackEvents["TAP_BTN_INT_PRICE_BREAKUP_DETAILS"] = "tap_btn_int_price_breakup_details";
    TravelInsuranceTrackEvents["TAP_BTN_INT_EDIT_DETAILS"] = "tap_btn_int_edit_details";
    TravelInsuranceTrackEvents["TAP_BTN_INT_CONTINUE"] = "tap_btn_int_continue";
    TravelInsuranceTrackEvents["TAP_BTN_INT_BUNDLED_JOURNEY"] = "tap_btn_int_bundled_journey";
    TravelInsuranceTrackEvents["TAP_BTN_INT_UNBUNDLED_JOURNEY"] = "tap_btn_int_unbundled_journey";
    TravelInsuranceTrackEvents["TAP_BTN_INT_BUNDLED_BASIC_PLAN_BENEFITS"] = "tap_btn_int_bundled_basic_plan_benefits";
    TravelInsuranceTrackEvents["TAP_BTN_INT_BUNDLED_COMFORT_PLAN_BENEFITS"] = "tap_btn_int_bundled_comfort_plan_benefits";
    TravelInsuranceTrackEvents["TAP_BTN_INT_BUNDLED_COMPARE"] = "tap_btn_int_bundled_compare";
    TravelInsuranceTrackEvents["TAP_BTN_INT_BUNDLED_PLAN"] = "tap_btn_int_bundled_plan";
    TravelInsuranceTrackEvents["TAP_BTN_INT_SELECT_ADD_ON"] = "tap_btn_int_select_add_on";
    TravelInsuranceTrackEvents["TAP_BTN_INT_ADD_DETAILS"] = "tap_btn_int_add_details";
    TravelInsuranceTrackEvents["TAP_BTN_INT_SKIP"] = "tap_btn_int_skip";
    TravelInsuranceTrackEvents["TAP_BTN_INT_TRIP_INFO_CONTINUE"] = "tap_btn_int_trip_info_continue";
    TravelInsuranceTrackEvents["TAP_BTN_INT_SEE_BENEFITS"] = "tap_btn_int_see_benefits";
    TravelInsuranceTrackEvents["TAP_BTN_INT_ADD_ON_TOGGLE"] = "tap_btn_int_add_on_toggle";
    TravelInsuranceTrackEvents["TAP_BTN_INT_ADD_COVER"] = "tap_btn_int_add_cover";
    TravelInsuranceTrackEvents["TAP_BTN_INT_SKIP_COVER"] = "tap_btn_int_skip_cover";
    TravelInsuranceTrackEvents["TAP_BTN_INT_UPDATE_COVERAGE_AMOUNT"] = "tap_btn_int_update_coverage_amount";
    TravelInsuranceTrackEvents["TAP_BTN_INT_VIEW_POLICY"] = "tap_btn_int_view_policy";
    TravelInsuranceTrackEvents["TAP_BTN_INT_DOWNLOAD_APP"] = "tap_btn_int_download_app";
    TravelInsuranceTrackEvents["TAP_BTN_INT_COPY_NOMINEE"] = "tap_btn_int_copy_nominee";
    TravelInsuranceTrackEvents["TAP_BTN_INT_CTA"] = "tap_btn_int_cta";
    TravelInsuranceTrackEvents["TAP_BTN_INT_SUM_INSURED_UPDATE"] = "tap_btn_int_sum_insured_update";
})(TravelInsuranceTrackEvents || (TravelInsuranceTrackEvents = {}));
var VAS = {
    JOURNEY: "visa assistance",
    SUB_PRODUCT_NAME: "visa_assistance",
    SERVICE: "visa2fly",
    VAS_ROUTER_QUERY: "vasQuery",
    VAS_HISTORY_REFERER: "vasReferer",
    VAS_MY_BOOKING_REFERER: "vasMyBookingsReferer",
    VAS_RESUME_BOOKING_REFERER: "vasResumeBookingReferer"
};
var DOMESTIC_PASS = {
    JOURNEY: "buy",
    SUB_PRODUCT_NAME: "travel_pass"
};
var VasPages;
(function(VasPages) {
    VasPages["TRAVEL_HOMEPAGE"] = "travel_homepage";
    VasPages["EXPLORE_PAGE"] = "explore_page";
    VasPages["TRAVEL_VISA_POST_PAYMENT_INSURANCE_NUDGE"] = "travel_visa_post_payment_insurance_nudge";
    VasPages["VIEW_MODAL_VISA_ASSISTANCE_COUNTRY_SELECTION"] = "view_modal_visa_assistance_country_selection";
    VasPages["TRAVEL_VISA_ASSISTANCE_COUNTRY_SELECTION_PAGE"] = "travel_visa_assistance_country_selection_page";
    VasPages["TRAVEL_VISA_REDIRECTION_LOADER"] = "travel_visa_redirection_loader";
    VasPages["TRAVEL_VISA_APPLICATION_SUCCESS"] = "travel_visa_application_successful";
    VasPages["TRAVEL_VISA_PAYMENT_INITIATION_LOADER"] = "travel_visa_payment_initiation_loader";
    VasPages["TRAVEL_VISA_PAYMENT_VERIFICATION_LOADER"] = "travel_visa_payment_verification_loader";
})(VasPages || (VasPages = {}));
var VasViewEvents;
(function(VasViewEvents) {
    VasViewEvents["VIEW_PAGE_EXPLORE"] = "view_page_explore";
    VasViewEvents["VIEW_PAGE_VISA_ASSISTANCE_COUNTRY_SELECTION_PAGE"] = "view_page_visa_assistance_country_selection_page";
    VasViewEvents["VIEW_MODAL_VISA_ASSISTANCE_COUNTRY_SELECTION"] = "view_modal_visa_assistance_country_selection";
    VasViewEvents["VIEW_PAGE_VISA_REDIRECTION_LOADER"] = "view_page_visa_redirection_loader";
    VasViewEvents["VIEW_PAGE_VISA_APPLICATION_SUCCESSFUL"] = "view_page_visa_application_successful";
    VasViewEvents["VIEW_PAGE_VISA_ASSISTANCE_TRAVEL_INSURANCE_NUDGE"] = "view_page_visa_assistance_travel_insurance_nudge";
    VasViewEvents["VIEW_PAGE_VISA_ASSISTANCE_PAYMENT_INITIATION"] = "view_page_visa_assistance_payment_initiation";
    VasViewEvents["VIEW_PAGE_VISA_ASSISTANCE_PAYMENT_VERIFICATION"] = "view_page_visa_assistance_payment_verification";
})(VasViewEvents || (VasViewEvents = {}));
var VasTrackEvents;
(function(VasTrackEvents) {
    VasTrackEvents["TAP_BTN_COUNTRY_SELECTION"] = "tap_btn_country_selection";
    VasTrackEvents["TAP_BTN_INT_CONTINUE"] = "tap_btn_int_continue";
    VasTrackEvents["TAP_BTN_COUNTRY_SEARCH_FILTER"] = "tap_btn_country_search_filter";
    VasTrackEvents["TAP_BTN_COUNTRY_SEARCH"] = "tap_btn_country_search";
    VasTrackEvents["TAP_BTN_INT_SKIP"] = "tap_btn_int_skip";
})(VasTrackEvents || (VasTrackEvents = {}));
var TravelPassPages;
(function(TravelPassPages) {
    TravelPassPages["TRAVEL_HOMEPAGE"] = "travel_homepage";
    TravelPassPages["FLIGHT_PASS_LANDING_PAGE"] = "flight_pass_landing_page";
    TravelPassPages["FLIGHT_PASS_LANDING_PAGE_BUY_MODAL"] = "flight_pass_landing_page_buy_modal";
    TravelPassPages["FLIGHT_PASS_POST_PAYMENT_ADDRESS_SETUP_PAGE"] = "flight_pass_post_payment_address_setup_page";
    TravelPassPages["FLIGHT_PASS_PAYMENT_INITIATED_PAGE"] = "flight_pass_payment_initiated_page";
    TravelPassPages["FLIGHT_PASS_PAYMENT_PROCESSING_PAGE"] = "flight_pass_payment_processing_page";
    TravelPassPages["FLIGHT_PASS_PAYMENT_SUCCESS_PAGE"] = "flight_pass_payment_success_page";
    TravelPassPages["FLIGHT_PASS_PAYMENT_FAILED_PAGE"] = "flight_pass_payment_failed_page";
    TravelPassPages["FLIGHT_PASS_POLICY_INIT_PAGE"] = "flight_pass_policy_init_page";
    TravelPassPages["FLIGHT_PASS_POLICY_SUCCESS_PAGE"] = "flight_pass_policy_success_page";
    TravelPassPages["FLIGHT_PASS_SAVED_ADDRESSES_MODAL"] = "flight_pass_saved_addresses_modal";
    TravelPassPages["FLIGHT_PASS_ADD_NEW_ADDRESS_MODAL"] = "flight_pass_add_new_address_modal";
    TravelPassPages["FLIGHT_PASS_ADDRESS_SAVED_PAGE"] = "flight_pass_address_saved_page";
    TravelPassPages["FLIGHT_PASS_APP_DOWNLOAD_PAGE"] = "flight_pass_app_download_page";
})(TravelPassPages || (TravelPassPages = {}));
var TravelPassViewEvents;
(function(TravelPassViewEvents) {
    TravelPassViewEvents["VIEW_PAGE_FLIGHT_PASS_LANDING_SCREEN"] = "view_page_flight_pass_landing_screen";
    TravelPassViewEvents["VIEW_MODAL_FLIGHT_PASS_USER_DETAILS"] = "view_modal_flight_pass_user_details";
    TravelPassViewEvents["VIEW_PAGE_FLIGHT_PASS_PAYMENT_SUCCESS"] = "view_page_flight_pass_payment_success";
    TravelPassViewEvents["VIEW_PAGE_FLIGHT_PASS_ADDRESS_NUDGE"] = "view_page_flight_pass_address_nudge";
    TravelPassViewEvents["VIEW_MODAL_FLIGHT_PASS_SAVED_ADDRESSES"] = "view_modal_flight_pass_saved_addresses";
    TravelPassViewEvents["VIEW_MODAL_FLIGHT_PASS_ADD_NEW_ADDRESS"] = "view_modal_flight_pass_add_new_address";
    TravelPassViewEvents["VIEW_PAGE_FLIGHT_PASS_ADDRESS_ADDED"] = "view_page_flight_pass_address_added";
    TravelPassViewEvents["VIEW_PAGE_FLIGHT_PASS_APP_DOWNLOAD_NUDGE"] = "view_page_flight_pass_app_download_nudge";
    TravelPassViewEvents["VIEW_PAGE_FLIGHT_PASS_SET_UP_COMPLETE"] = "view_page_flight_pass_set_up_complete";
})(TravelPassViewEvents || (TravelPassViewEvents = {}));
var TravelPassTrackEvents;
(function(TravelPassTrackEvents) {
    TravelPassTrackEvents["TAP_BTN_CONTINUE"] = "tap_btn_continue";
    TravelPassTrackEvents["TAP_BTN_INT_BACK"] = "tap_btn_back";
})(TravelPassTrackEvents || (TravelPassTrackEvents = {}));
var EventType = {
    TAP: "tap",
    VIEW: "view"
};
var AppsFlyerEvents;
(function(AppsFlyerEvents) {
    AppsFlyerEvents["INT_LEAD_ENTERED"] = "int_lead_entered";
    AppsFlyerEvents["INT_QUOTE_GENERATED_BUNDLED"] = "int_quote_generated_bundled";
    AppsFlyerEvents["INT_QUOTE_GENERATED_UNBUNDLED"] = "int_quote_generated_unbundled";
    AppsFlyerEvents["INT_PAYMENT_COMPLETED"] = "int_payment_completed";
})(AppsFlyerEvents || (AppsFlyerEvents = {}));
var AppsFlyer;
(function(AppsFlyer) {
    AppsFlyer["ACTION"] = "send_event";
    AppsFlyer["DESTINATION"] = "firebase";
})(AppsFlyer || (AppsFlyer = {}));
var HindustanTimesPartner = {
    action: "advLPClick",
    type: {
        leadSubmit: "leadSubmit",
        buttonClick: "buttonClick"
    },
    campaign: "AckoTravelInsurance",
    source: "ht",
    medium: "display",
    event: "event",
    pages: {
        tripInfo: "tripInfo",
        bundledPlan: "bundledPlan",
        bundledAddon: "bundledAddon",
        unbundledPlan: "unbundledPlan",
        travellersDetails: "travellersDetails",
        checkout: "checkout",
        paymentSuccess: "paymentSuccess"
    }
};


/***/ }),

/***/ 56073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AL": function() { return /* binding */ TravelActionType; },
/* harmony export */   "Cr": function() { return /* binding */ BUNDLED_PLAN_CATEGORIES; },
/* harmony export */   "DQ": function() { return /* binding */ StateToViewEventsMapper; },
/* harmony export */   "Dt": function() { return /* binding */ APPLY_COUPON_RESPONSE_CODE; },
/* harmony export */   "Fe": function() { return /* binding */ PHONE_ERROR; },
/* harmony export */   "GV": function() { return /* binding */ PageType; },
/* harmony export */   "Hs": function() { return /* binding */ COUPON_CARD_ACTIONS; },
/* harmony export */   "KZ": function() { return /* binding */ BundledDesktopStages; },
/* harmony export */   "Rj": function() { return /* binding */ StateToPersuasionMapper; },
/* harmony export */   "TX": function() { return /* binding */ internationalInsuranceUsps; },
/* harmony export */   "UW": function() { return /* binding */ APPLY_COUPON_MESSAGES; },
/* harmony export */   "Uc": function() { return /* binding */ Stages; },
/* harmony export */   "Uf": function() { return /* binding */ partnerWidgetTravellers; },
/* harmony export */   "Vn": function() { return /* binding */ StateToPageMapper; },
/* harmony export */   "WD": function() { return /* binding */ Category; },
/* harmony export */   "_o": function() { return /* binding */ PASSPORT_ERRORS; },
/* harmony export */   "rH": function() { return /* binding */ COUPON_TYPE; },
/* harmony export */   "sx": function() { return /* binding */ UnbundledDesktopStages; },
/* harmony export */   "vR": function() { return /* binding */ REQUIRED_FIELD_ERROR; },
/* harmony export */   "w$": function() { return /* binding */ NAME_ERRORS; },
/* harmony export */   "xF": function() { return /* binding */ CoverTypeList; },
/* harmony export */   "yR": function() { return /* binding */ PackageType; },
/* harmony export */   "yx": function() { return /* binding */ MISSING_FIELDS_ERROR; }
/* harmony export */ });
/* unused harmony exports CurrencyType, modalTypes, LongTermConditions, TravelPassStateToPageMapper */
/* harmony import */ var src_common_utils_api_urls__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30207);
/* harmony import */ var src_common_utils_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79354);
/* harmony import */ var src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19659);



var TravelActionType = {
    COLLECT_TRAVEL_DETAILS: "collect_travel_details",
    SHOW_STORIES: "show_stories",
    COLLECT_MEDICAL_COVER: "collect_medical_cover",
    COLLECT_PLANS: "collect_plans",
    COLLECT_ADDONS: "collect_addons",
    COLLECT_TRAVELLER_DETAILS: "collect_traveller_details",
    CHECKOUT: "checkout",
    INITIATE_PAYMENT: "initiate_payment",
    CONFIRM_PAYMENT: "confirm_payment",
    LOAD_POLICY: "load_policy",
    INITIATE_KYC: "initiate_kyc",
    TRIP_INFO: "tripInfo",
    POLICY_ACTIVATED: "policy_activated",
    COMPLIANCE_PENDING: "compliance_pending"
};
var COUPON_CARD_ACTIONS = {
    APPLY: "apply coupon",
    REMOVE: "remove coupon",
    SEE_ALL_COUPONS: "see all coupons",
    SEE_DETAILS: "see coupon details"
};
var APPLY_COUPON_RESPONSE_CODE = {
    SUCCESS: "SUCCESS",
    INVALID: "INVALID_CODE"
};
var COUPON_TYPE = "COUPON";
var APPLY_COUPON_MESSAGES = {
    SUCCESS: "Coupon applied successfully!",
    INVALID: "Only one coupon can be applied!",
    DEFAULT: "Oops! This coupon is not valid",
    ERROR: "Oops! Something went wrong. Please try again."
};
var UnbundledDesktopStages = [
    "Trip info",
    "Build plan",
    "Personal details",
    "Review & Pay", 
];
var BundledDesktopStages = [
    "Trip info",
    "Choose plan",
    "Personal details",
    "Review & Pay", 
];
var Stages = [
    "Trip info",
    "Plan info",
    "Details",
    "Checkout"
];
var PackageType = {
    UNBUNDLED: "unbundled",
    BUNDLED: "bundled"
};
var CoverTypeList = [
    src_common_utils_api_urls__WEBPACK_IMPORTED_MODULE_0__/* .CoverType.MEDICAL */ .gW.MEDICAL,
    src_common_utils_api_urls__WEBPACK_IMPORTED_MODULE_0__/* .CoverType.TRIP */ .gW.TRIP,
    src_common_utils_api_urls__WEBPACK_IMPORTED_MODULE_0__/* .CoverType.BAGGAGE */ .gW.BAGGAGE, 
];
var PageType = {
    unbundled: "unbundled_only_cohort",
    bundled: "bundled_only_cohort",
    default: "buy"
};
var Category = {
    SENIOR_CITIZEN: "senior_citizen",
    ADULT: "adult",
    CHILD: "child",
    CHILDREN: "children"
};
var CurrencyType = {
    INR: "₹",
    USD: "$"
};
var modalTypes = {
    benefits: {
        label: "Medical cover benefits",
        type: "benefits"
    },
    claimAmount: {
        label: "Hospitalisation bills coverage",
        type: "claim amount"
    },
    medicalUsage: {
        label: "How to use this cover?",
        type: "medical usage"
    }
};
var LongTermConditions = (/* unused pure expression or super */ null && ([
    "Hypertension",
    "Diabetes mellitus",
    "Chronic illness",
    "Asthma",
    "Thyroid",
    "High bood pressure",
    "Epilepsy",
    "Lupus", 
]));
var PASSPORT_ERRORS = {
    DUPLICATE: "This passport number is linked to another traveller in this policy",
    EMPTY: "We need your passport number",
    INVALID: "Please enter a valid passport number"
};
var NAME_ERRORS = {
    INVALID_FORMAT: "Special characters like @, #, $ are not allowed"
};
var REQUIRED_FIELD_ERROR = "This is a required field";
var PHONE_ERROR = "Please enter a valid mobile number";
var MISSING_FIELDS_ERROR = "Please enter the required fields";
var BUNDLED_PLAN_CATEGORIES = {
    COMFORT: "comfort",
    SMART: "smart"
};
var StateToPageMapper = {
    package_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_FORK_SCREEN */ .I6.INT_TRAVEL_FORK_SCREEN,
    medical_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_UNBUNDLED_MEDICAL_COVER */ .I6.INT_TRAVEL_UNBUNDLED_MEDICAL_COVER,
    trip_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_UNBUNDLED_TRIP_COVER */ .I6.INT_TRAVEL_UNBUNDLED_TRIP_COVER,
    baggage_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_UNBUNDLED_BAGGAGE_COVER */ .I6.INT_TRAVEL_UNBUNDLED_BAGGAGE_COVER,
    bundled_addon_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_BUNDLED_ADDON_SCREEN */ .I6.INT_TRAVEL_BUNDLED_ADDON_SCREEN,
    bundled_plan_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_BUNDLED_PLAN_SELECTION_SCREEN */ .I6.INT_TRAVEL_BUNDLED_PLAN_SELECTION_SCREEN,
    journey_summary: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_REVIEW_SCREEN */ .I6.INT_TRAVEL_REVIEW_SCREEN,
    trip_details_collection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_TRIP_INFO_SCREEN */ .I6.INT_TRAVEL_TRIP_INFO_SCREEN,
    traveller_details_updation: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_TRAVELLERS_DETAILS_SCREEN */ .I6.INT_TRAVEL_TRAVELLERS_DETAILS_SCREEN,
    compliance_pending: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_POST_PAYMENT_ADD_DETAILS_SCREEN */ .I6.INT_TRAVEL_POST_PAYMENT_ADD_DETAILS_SCREEN,
    policy_activated: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_BUY_JOURNEY_SUCCESS_SCREEN */ .I6.INT_TRAVEL_BUY_JOURNEY_SUCCESS_SCREEN,
    policy_compliance_initiated: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_POST_PAYMENT_TRAVELLERS_DETAILS */ .I6.INT_TRAVEL_POST_PAYMENT_TRAVELLERS_DETAILS,
    payment_pending: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_PAYMENT_PENDING_SCREEN */ .I6.INT_TRAVEL_PAYMENT_PENDING_SCREEN,
    null: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.HOME */ .I6.HOME,
    vas: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .VasPages.TRAVEL_VISA_POST_PAYMENT_INSURANCE_NUDGE */ .ZD.TRAVEL_VISA_POST_PAYMENT_INSURANCE_NUDGE,
    seo: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.SEO */ .I6.SEO
};
var TravelPassStateToPageMapper = {
    landing_page: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelPassPages.FLIGHT_PASS_LANDING_PAGE */ .tH.FLIGHT_PASS_LANDING_PAGE,
    payment_initiated: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelPassPages.FLIGHT_PASS_PAYMENT_INITIATED_PAGE */ .tH.FLIGHT_PASS_PAYMENT_INITIATED_PAGE,
    payment_processing: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelPassPages.FLIGHT_PASS_PAYMENT_PROCESSING_PAGE */ .tH.FLIGHT_PASS_PAYMENT_PROCESSING_PAGE,
    payment_success: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelPassPages.FLIGHT_PASS_PAYMENT_SUCCESS_PAGE */ .tH.FLIGHT_PASS_PAYMENT_SUCCESS_PAGE,
    payment_failed: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelPassPages.FLIGHT_PASS_PAYMENT_FAILED_PAGE */ .tH.FLIGHT_PASS_PAYMENT_FAILED_PAGE,
    policy_init: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelPassPages.FLIGHT_PASS_POLICY_INIT_PAGE */ .tH.FLIGHT_PASS_POLICY_INIT_PAGE,
    policy_success: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelPassPages.FLIGHT_PASS_POLICY_SUCCESS_PAGE */ .tH.FLIGHT_PASS_POLICY_SUCCESS_PAGE
};
var StateToViewEventsMapper = {
    medical_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsuranceViewEvents.VIEW_PAGE_INT_MEDICAL_COVER */ .e2.VIEW_PAGE_INT_MEDICAL_COVER,
    trip_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsuranceViewEvents.VIEW_PAGE_INT_TRIP_COVER */ .e2.VIEW_PAGE_INT_TRIP_COVER,
    baggage_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsuranceViewEvents.VIEW_PAGE_INT_BAGGAGE_COVER */ .e2.VIEW_PAGE_INT_BAGGAGE_COVER,
    policy_compliance_initiated: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsuranceViewEvents.VIEW_PAGE_PAYMENT_SUCCESS_ADD_DETAILS */ .e2.VIEW_PAGE_PAYMENT_SUCCESS_ADD_DETAILS
};
var StateToPersuasionMapper = {
    medical_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_MEDICAL_COVER_PERSUASION_MODAL */ .I6.INT_TRAVEL_MEDICAL_COVER_PERSUASION_MODAL,
    trip_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_TRIP_COVER_PERSUASION_MODAL */ .I6.INT_TRAVEL_TRIP_COVER_PERSUASION_MODAL,
    baggage_cover_selection: src_common_utils_segment_types__WEBPACK_IMPORTED_MODULE_2__/* .TravelInsurancePages.INT_TRAVEL_BAGGAGE_COVER_PERSUASION_MODAL */ .I6.INT_TRAVEL_BAGGAGE_COVER_PERSUASION_MODAL
};
var partnerWidgetTravellers = [
    {
        index: 0,
        count: 0,
        category: "adult",
        title: "Adult",
        sub_title: "18-60 years"
    },
    {
        index: 1,
        count: 0,
        category: "child",
        title: "Child",
        sub_title: "below 18 years"
    },
    {
        index: 2,
        count: 0,
        category: "senior_citizen",
        title: "Senior citizen",
        sub_title: "60-70 years",
        note: {
            icon_url: "https://travel.ackoassets.com/images/info.svg",
            text: "We do not cover travellers aged 70 and above"
        }
    }, 
];
var internationalInsuranceUsps = [
    {
        image_url: src_common_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .INTERNATIONAL_DESKTOP_ASSETS.PASSPORT_ICON */ .FJ.PASSPORT_ICON,
        description: "Visa compliant policies"
    },
    {
        image_url: src_common_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .INTERNATIONAL_DESKTOP_ASSETS.CUSTOMER_SUPPORT */ .FJ.CUSTOMER_SUPPORT,
        description: "9 out 10 claims settled within 24 hours"
    },
    {
        image_url: src_common_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .INTERNATIONAL_DESKTOP_ASSETS.MONEY_ICON */ .FJ.MONEY_ICON,
        description: "Prices starting at Rs. 10/day*"
    },
    {
        image_url: src_common_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .INTERNATIONAL_DESKTOP_ASSETS.NOTES_ICON */ .FJ.NOTES_ICON,
        description: "Cancel or edit your policy on our app any time"
    }, 
];


/***/ })

}]);